import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostListener,
  OnDestroy,
  NgZone,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './Confirmdialog.component.html',
  styleUrls: ['./Confirmdialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnDestroy {
  @Input() title: string = 'Confirmer la suppression';
  @Input() message: string = 'Êtes-vous sûr de vouloir supprimer cet élément ?';
  @Input() itemLabel: string = '';
  @Input() confirmLabel: string = 'Supprimer';
  @Input() cancelLabel: string = 'Annuler';
  @Input() isLoading: boolean = false;
  @Input() blockedChildCount: number = 0;

  @Input() set isVisible(val: boolean) {
    this._isVisible = val;
    if (val && !this.isBlocked) {
      this._startCountdown();
    } else {
      this._clearCountdown();
    }
  }
  get isVisible(): boolean { return this._isVisible; }

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  private _isVisible: boolean = false;

  readonly COUNTDOWN = 3;
  countdown: number = this.COUNTDOWN;
  get confirmReady(): boolean { return this.countdown === 0; }

  private _intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {}

  get isBlocked(): boolean {
    return this.blockedChildCount > 0;
  }

  private _startCountdown(): void {
    this._clearCountdown();
    this.countdown = this.COUNTDOWN;

    // runOutsideAngular pour ne pas déclencher de CD à chaque tick
    // puis re-entre dans la zone uniquement pour la mise à jour du compteur
    this.ngZone.runOutsideAngular(() => {
      this._intervalId = setInterval(() => {
        this.ngZone.run(() => {
          this.countdown--;
          this.cd.markForCheck();
          if (this.countdown <= 0) this._clearCountdown();
        });
      }, 1000);
    });
  }

  private _clearCountdown(): void {
    if (this._intervalId !== null) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }

  confirm(): void {
    if (this.isLoading || this.isBlocked || !this.confirmReady) return;
    this.confirmed.emit();
  }

  cancel(): void {
    if (this.isLoading) return;
    this._clearCountdown();
    this.cancelled.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isVisible) this.cancel();
  }

  ngOnDestroy(): void {
    this._clearCountdown();
  }
}